<template>
  <!-- 产品 -->
  <dynamic-tooltip  :content="getTextWithRegex(data.prodName)" :fontSize="16">
    <div
      class="list-card simple-click-hover list-edit-parent"
      @click="openProductDetail"
      :style="cardStyle"
    >
    
      <!-- 产品主图 -->
      <div class="img-body">
        <prod-icon :src="data.prodLogo" :width="165" :height="165"></prod-icon>
      </div>
     
      <div class="card-info">
        <!-- 产品详情(产品名称、浏览/下载量) -->
        <div class="card-mid">
          <p class="text-clamp2" v-html="stringFilter(data.prodName||'')"></p>
        </div>
        <div style="margin-bottom: 6px;padding: 6px;"><Tag size="small" :class="handleColor(data.modelSimiarity)" >相似度{{data.modelSimiarity}}%</Tag></div>
        <div class="card-btm-empty" v-if="showComp"></div>
        <router-link :to="`/company/home/${data.compId}`" :target="OpenService.getRouterTarget()" class="card-btm" v-if="showComp">
          <!-- 金牌/银牌/铜牌/无 + 公司名称-->
          <div class="auth-type" @click.stop="">
            <vip-level :curData="data" :width="16"></vip-level>
            <span v-html="stringFilter(data.compName || data.promoteName||'')"></span>
          </div>
        </router-link>
      </div>
    
      <slot name="footer"></slot>
    </div>
   </dynamic-tooltip>
  

 
</template>

<script>
import { OpenService } from "@/service";
import ProdIcon from "/@/components/icon/prod-icon.vue";
import VipLevel from "/@/components/icon/vip-level.vue";
import DynamicTooltip from "/@/components/dynamicTooltip.vue";
import {Tag} from 'element-ui'

export default {
  components: {
    ProdIcon,
    VipLevel,
    DynamicTooltip,
    Tag
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    type: {
      type: String,
      default: "prod",
    },
    cardStyle: { dafault: {} },
    /**产品类别时是否显示底部企业信息 */
    showComp: { default: true },
  },
  data() {
    return {
      OpenService
    };
  },
  methods: {
    handleColor(num) {
        if(num < 25) {
            return 'gray-tag'
        }else if(num < 50) {
            return 'yellow-tag'
        }else if(num < 75) {
            return 'orange-tag';
        }else {
            return 'green-tag'
        }
    },
    stringFilter(value) {
      return value ? value.toString() : value;
    },
    _cardMouseover(e) {
      this.$emit('mouseover', e);
    },
    _cardMouseout(e) {
      this.$emit('mouseout', e);
    },
    openProductDetail() {
      OpenService.openProdDetails(this.data.prodId);
    },
    getTextWithRegex(html) {
      return html ?  html.toString().replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() : html;
    }
  },
};
</script>

<style lang="less" scoped>
// 产品卡片
.list-card {
  position: relative;
//   font-size: 0;
  min-width: 150px;
  max-width: 180px;
  flex: 1;
  text-decoration: none;
  background: #ffffff;
  display: block;
  .img-body{
    padding: 3px;
    align-items: center;
    justify-content: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 150px;
    overflow: hidden;
    img{
      object-fit: contain;
      max-width: 100%;
    }
  }
}
::v-deep .el-tag.orange-tag{
    background: #FF8C00;
    color: #fff;
}
::v-deep .el-tag.yellow-tag {
    background: #FFCE47;
    color: #fff;
}
::v-deep .el-tag.gray-tag {
    background: #ACACAC;
    color: #fff;
}
::v-deep .el-tag.green-tag {
    color: #fff;
    background: #169200;
}

.card-info {
  background: #ffffff;
}

.card-mid {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 37px;
  padding: 5px 5px 0;
  // 产品名称
  p {
    overflow: hidden;
    font-size: 14px;
    color: #111a2a;
    margin: 0;
  }
  /deep/ em{
    font-style: initial;
    color: #dc0000;
  }
}

// 浏览/下载
.card-num {
  margin-bottom: 5px;
  margin-top: 6px;
  font-size: 12px;
  color: #9f9e9e;
  padding: 0 5px;
}

.card-btm-empty{
  width: 100%;
  height: 28px;
}
.card-btm {
  text-decoration: none;
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  // 金/银/铜 + 公司名称
  .auth-type {
    display: flex;
    align-items: center;
    height: 28px;
    padding: 0 2px;
    background: @content-bg;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      color: @text-color-call-out;
    }
    /deep/ em{
      font-style: initial;
      color: #dc0000;
    }
    /deep/ .vip-level{
      margin-right: 4px;
    }
  }
}
.popularize-sign{
  width: 30px;
  height: 18px;
  background: rgba(51, 51, 51, 0.6);
  opacity: 0.67;
  font-size: 10px;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  line-height: 18px;
}
</style>
